import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Header from './components/layout/Header';
import Main from './components/Main';
import './App.css';
import Service from './components/Services';
import Company from './components/Company';
import Addtions from './components/Additions';
import News from './components/News';
import Partner from './components/Partner';
import Contact from './components/Contact';
import MobilePage from './components/mobile/MobilePage';
import CorporatePage from './components/corporate/CorporatePage';
import ScrollToTop from './components/ScrollToTop';

/** 자체 헤더를 쓰고 모바일까지 반응형으로 대응하는 페이지들 */
const ONE_PAGE_PATHS = ['/', '/bnpl'];

const App = () => {

  const location = useLocation();
  const pathname = location.pathname;
  const isOnePage = ONE_PAGE_PATHS.includes(pathname);

  useEffect(() => {
    console.log("Path changed to:", location.pathname);
    // 여기서 경로 변경을 감지하여 원하는 동작 수행
  }, [location]);

  return (

    <>
      <ScrollToTop />

      {/* 메인('/')은 반응형이라 모바일에서도 그대로 보여준다.
          나머지 페이지는 아직 데스크톱 전용이라 기존 안내 화면을 유지한다. */}
      {isMobile && !isOnePage ? (
        <MobilePage />
      ) :

      (
        /* 메인('/')과 BNPL 접수('/bnpl')는 시안 원페이지라 높이를 100vh로 묶지 않고,
           자체 sticky 헤더를 쓰므로 공용 Header를 렌더하지 않는다. */
        <div className={`${isOnePage ? 'appOne' : 'appCalc'}`}>
          {!isOnePage && <Header background={false} />} { /* 헤더 */}
          <div className={isOnePage ? 'contentOne' : 'content'}>
            <Routes>
              <Route path='/' element={<CorporatePage />}/> {/* 기업 소개 메인 */}
              <Route path='/bnpl' element={<Main />}/> {/* BNPL 상담·접수 원페이지 */}
              <Route path='/company' element={<Company />}/> {/* 회사 소개 페이지 */}
              <Route path='/services' element={<Service />}/> { /* 서비스 페이지 */}
              <Route path='/addtions' element={<Addtions />}/> {/* 부가서비스 페이지 */}
              <Route path='/news' element={<News />}/> { /* 보도자료 페이지 */}
              <Route path='/partner' element={<Partner />}/> {/* 제휴사모집 페이지 */}
              <Route path='/contact' element={<Contact />}/> { /* 문의하기 페이지 */}
            </Routes>
          </div>
        </div>
      )
      }
    </>
  )

}

export default App;
